import { compact } from "lodash"
export const INVALID_VALUES = [
  "",
  "undefined",
  undefined,
  "0,00",
  "null",
  null,
  "NaN",
  NaN,
] as const

export const substring = (
  value?: string,
  init: number = 0,
  end: number = 0
) => {
  try {
    if (value) return value.substring(init, end)
    return ""
  } catch {
    return ""
  }
}

export const objectToQueryString = (
  obj: Record<string, unknown>
) => {
  return Object.entries(obj)
    .filter(
      ([, value]) =>
        !INVALID_VALUES.includes(value as never)
    )
    .map(([key, value]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    })
    .join("&")
}

export const onlyNumbers = (value?: string) => {
  try {
    if (value) return value.replace(/\D/g, "")
    return value
  } catch {
    return ""
  }
}

export const onlyAlphanumeric = (value?: string) => {
  try {
    if (value) return value.replaceAll(/[^a-zA-Z0-9]/g, "")
    return value
  } catch {
    return ""
  }
}

export const isNullOrEmpty = (
  ...args: unknown[]
): boolean => {
  return compact(args).length === 0
}

export const stringify = (value: unknown): string => {
  try {
    if (value) return JSON.stringify(value)
    return ""
  } catch {
    return ""
  }
}

export const encodeBase64 = (value: string) => {
  try {
    return btoa(encodeURI(value))
  } catch (error) {
    console.error(error)
    return ""
  }
}

export const decodeBase64 = (value: string) => {
  try {
    return decodeURI(value)
  } catch (error) {
    console.error(error)
    return ""
  }
}

export const formatPercentage = (value: number) => {
  return `${value}%`
}

export const getEmailDomain = (email: string) => {
  if (typeof email !== "string") {
    throw new TypeError("email must be a string")
  }
  const atIndex = email.indexOf("@")
  return atIndex === -1
    ? ""
    : email.slice(atIndex + 1).trim()
}

export const destructuringPhone = (phone: string) => {
  const cleanedPhone = onlyNumbers(phone) || ""
  if (cleanedPhone.length < 10) {
    throw new Error("Telefone inválido")
  }
  const areaCode = cleanedPhone.slice(0, 2)
  const number = cleanedPhone.slice(2)
  return {
    countryCode: "55",
    areaCode,
    number,
  }
}
